var ContainerTypeApiData = /** @class */ (function () {
    function ContainerTypeApiData() {
    }
    return ContainerTypeApiData;
}());
export { ContainerTypeApiData };
//# sourceMappingURL=container-type-api-data.js.map


//////////////////
// WEBPACK FOOTER
// ../od-ts/dist/end-points-dto/api-dto/spaces/container-type-api-data.js
// module id = 884
// module chunks = 14